import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { identifyComponent } from '../../util';
import { Text } from '../Text';
import css from './index.module.scss';

type BadgeVariant =
  | 'default'
  | 'default-inverse'
  | 'brand'
  | 'intelligence'
  | 'success'
  | 'error'
  | 'intelligence-border';

export interface BadgeProps extends React.ComponentPropsWithoutRef<'span'> {
  /**
   * Type of badge. Default is `default`
   */
  variant?: BadgeVariant;
  /**
   * Text to display on the badge.
   */
  children: React.ReactNode;
}

export const Badge = ({ variant = 'default', children, ...props }: BadgeProps) => (
  <span
    data-component="Badge"
    className={classNames(css.badge, css[variant])}
    {...props}
    {...identifyComponent('badge', props)}
  >
    <Text noWrap appearance="bodyXSmallBold" color="inherit" tag="span">
      {children}
    </Text>
  </span>
);
